import { CheckBox, Form, TextArea, TextBox } from 'devextreme-react';
import { ButtonItem, EmptyItem, Label, SimpleItem } from 'devextreme-react/form';
import { Component } from 'react';

class FormSectionProps extends Component {
    state = {
        section: this.props.section ?? {}
    }

    set = updater => {
        updater(this.state.section);
        this.forceUpdate();
    }

    render() {
        return (
            <Form rtlEnabled colCount={60} width='50rem' height='auto'>
                <SimpleItem colSpan={30} >
                    <Label text='نام' />
                    <TextBox rtlEnabled value={this.state.section.name} onValueChanged={e => this.set(f => f.name = e.value)}
                    />
                </SimpleItem>
                <SimpleItem colSpan={30}>
                    <Label text='عنوان' />
                    <TextBox rtlEnabled value={this.state.section.caption_FA} onValueChanged={e => this.set(f => f.caption_FA = e.value)}
                    />
                </SimpleItem>
                {/* <SimpleItem colSpan={30}>
                    <Label text='نمایش عنوان' />
                    <CheckBox rtlEnabled value={this.state.section.showText !== false} onValueChanged={e => this.set(f => f.showText = e.value !== false)}
                    />
                </SimpleItem> 
                */}
                <SimpleItem colSpan={60}>
                    <Label text='استایل' />
                    <TextArea rtlEnabled={false} className='mdh-left-align' minHeight='5rem' autoResizeEnabled
                        value={this.state.section.jsStyle ?? '{\n}'} onValueChanged={e => this.set(f => f.jsStyle = e.value ?? '{}')}
                    />
                </SimpleItem>

                <EmptyItem colSpan={60} />

                <ButtonItem colSpan={15} buttonOptions={{
                    text: 'قبول', icon: 'check', width: '90%', type: 'success',
                    onClick: () => this.props.onOk(this.state.section)
                }}
                />

                <ButtonItem colSpan={15} buttonOptions={{
                    text: 'رد', icon: 'close', width: '90%', type: 'danger',
                    onClick: () => this.props.onCancel()
                }} />

            </Form >
        );
    }
}

export default FormSectionProps;